import initializeFacebook from "app/scripts/initialize_facebook"
import modalHandler from "shared/scripts/modal"
import shareButton from "shared/scripts/share_button"

export function initializeSharing() {
  modalHandler()
  initializeFacebook()
  shareButton()
}
